import { ArrowLeft } from '@sweep-io/sweep-design/dist/icons';
import { Box } from '@mui/material';
import { Button, IconButton, Tooltip, Typography } from '@sweep-io/sweep-design';
import { ConfigurationCanvasPanelHeader } from '../../../configuration-canvas-panel';

interface TemplatesPageHeaderProps {
  onBackClick: () => void;
  title: string;
  imageIcon?: React.ReactNode;
  onButtonClick: () => void;
  buttonText: string;
  isButtonDisabled?: boolean;
  buttonDisabledTooltip?: string;
}
export const TemplatesPageHeader = ({
  onBackClick,
  buttonText,
  title,
  onButtonClick,
  imageIcon,
  isButtonDisabled,
  buttonDisabledTooltip,
}: TemplatesPageHeaderProps) => {
  return (
    <ConfigurationCanvasPanelHeader>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <IconButton variant="flat" size="tiny" onClick={onBackClick}>
            <ArrowLeft size="medium" />
          </IconButton>
          <Box sx={{ '& svg': { width: '24px', height: '24px', marginTop: '5px' } }}>
            {imageIcon}
          </Box>

          <Typography variant="h4">{title}</Typography>
        </Box>
        <Tooltip title={isButtonDisabled ? buttonDisabledTooltip : undefined}>
          <span>
            <Button
              size="small"
              variant="primary"
              onClick={onButtonClick}
              disabled={isButtonDisabled}
            >
              {buttonText}
            </Button>
          </span>
        </Tooltip>
      </Box>
    </ConfigurationCanvasPanelHeader>
  );
};
